module.exports = __webpack_public_path__ + "static/media/Omnivati-Logo-Tagline.7ea9e097.jpg";